  // Product tab click handler
  document.addEventListener('click', function (e) {

    const link = e.target.closest('.product-tab-list a');
    if (!link) return;

    // Prevent default only for tab links
    e.preventDefault();

    const productTab = link.closest('.product-tab');
    if (!productTab) return;

    const hrefId = link.getAttribute('href');

    productTab.querySelectorAll('a').forEach(a => a.classList.remove('active'));
    productTab.querySelectorAll('.tab-panal').forEach(panel => panel.classList.remove('active'));

    link.classList.add('active');

    const targetPanel = document.querySelector(hrefId);
    if (targetPanel) targetPanel.classList.add('active');
  });



// window.addEventListener('load', function () {

//   function moveConversagent() {
//     if (window.innerWidth > 767) return;

//     const conversagent = document.querySelector('.conversagent-wrapper');
//     const mobileChatbot = document.querySelector('.mobile-chatbot');

//     if (conversagent && mobileChatbot && !mobileChatbot.contains(conversagent)) {
//       mobileChatbot.appendChild(conversagent);
//     }
//   }

//   // Run after full page load + small delay for app widget render
//   setTimeout(moveConversagent, 2000);

//   // Watch for app widget injected after load
//   const observer = new MutationObserver(function () {
//     moveConversagent();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

//   // Handle resize
//   window.addEventListener('resize', moveConversagent);

// });



window.addEventListener("load", function () {
  const cssToInject = `
    .cs-chat-wrapper {
      padding: 26px 20px 90px 50px !important;
      background-image: url("https://cdn.shopify.com/s/files/1/0781/4886/2258/files/Rectangle_2168.png?v=1765198399") !important;
    }

    .cs-chat-item .cs-a {
      padding: 14px 40px !important;
      border-radius: 15px !important;
      margin-bottom: 45px !important;
      clear: both !important;
      font-size: 13px !important;
      background: #fff !important;
      border: 0 !important;
      line-height: 1.3 !important;
      font-weight: 500 !important;
    }

    .cs-chat-wrapper .cs-input-wrapper {
      width: 90% !important;
      position: absolute !important;
      bottom: 50px;
      left: 50%;
      transform: translateX(-50%);
    }

    .cs-chat-item .cs-a-wrapper {
      max-width: 100% !important;
      float: left;
      padding: 0 !important;
    }

    @media(max-width:767px){
      .cs-chat-wrapper {
        padding: 10px 10px 60px 40px !important;
      }

      .cs-chat-item .cs-a {
        padding: 14px 10px 10px 40px;
        margin-bottom: 85px;
        font-size: 12px;
      }

      .cs-chat-wrapper .cs-input-wrapper {
        bottom: 30px;
      }

      .cs-chat-wrapper .cs-content-wrapper {
        max-width: 100%;
      }
    }
  `;

  function injectCSS(shadow) {
    if (!shadow) return false;

    if (shadow.querySelector("#clever-custom-style")) {
      return true;
    }

    const style = document.createElement("style");
    style.id = "clever-custom-style";
    style.textContent = cssToInject;

    shadow.appendChild(style);

    console.log("CSS injected into Clever Chat");
    return true;
  }

  function watchShadowRoot(clever) {
    if (!clever || !clever.shadowRoot) {
      return false;
    }

    const shadow = clever.shadowRoot;

    injectCSS(shadow);

    if (!clever.__cleverObserverAttached) {
      clever.__cleverObserverAttached = true;

      const observer = new MutationObserver(function () {
        injectCSS(shadow);
      });

      observer.observe(shadow, {
        childList: true,
        subtree: true
      });

      console.log("Observer attached to Clever shadow DOM");
    }

    return true;
  }

  const loader = setInterval(function () {
    const clever = document.querySelector("clever-search-chat");

    if (!clever) return;

    const ready = watchShadowRoot(clever);

    if (ready) {
      clearInterval(loader);
    }
  }, 300);
});




